import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {REPORT_ROUTES} from './report.routes';

const routes: Routes = REPORT_ROUTES;

@NgModule({
  exports:[RouterModule],
  imports: [
    RouterModule.forChild(routes)
  ],
  declarations: []
})
export class ReportRoutingModule { }
